import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import loadingReducer from './helpers/loading_reducer';
import batteryReducer from './helpers/battery_reducer';
import batterySohReducer from './helpers/battery_soh';
import assetReducer from './helpers/asset_reducer';
import atypicalReducer from './helpers/atypical_reducer';
import genericReducer from './helpers/generic_reducer';
import contractReducer from './helpers/contract_reducer';
import tableBatteryReducer from './helpers/table_battery_reducer';
import meterReducer from './helpers/meter_reducer';
import unavailabilitiesReducer from './helpers/unavailabilities_reducer';
import statusReducer from './helpers/status_reducer';
import statusRangeReducer from './helpers/status_range_reducer';
import authReducer from './auth_reducer';
import dateRangeReducer from './date_range_reducer';
import modeReducer from './mode_reducer';
import tableReducer from './table_reducer';
import tariffReducer from './helpers/tariff_reducer';
import errorsReducers from './errors_reducers';
import chartDataReducer from './chart_data_reducer';
import siteDataReducer from './site_data_reducer';
import tableDateRangeReducer from './table_date_range_reducer';
import permissionsReducer from './permissions_reducer';
import { configReducer } from './config';

export default history =>
  combineReducers({
    router: connectRouter(history),
    loading: loadingReducer,
    battery: batteryReducer,
    batterySoh: batterySohReducer,
    asset: assetReducer,
    atypicalPS: atypicalReducer,
    genericPS: genericReducer,
    contract: contractReducer,
    meter: meterReducer,
    unavailabilities: unavailabilitiesReducer,
    status: statusReducer,
    statusRange: statusRangeReducer,
    auth: authReducer,
    dateRange: dateRangeReducer,
    tableDateRange: tableDateRangeReducer,
    mode: modeReducer,
    table: tableReducer,
    tariff: tariffReducer,
    error: errorsReducers,
    chartData: chartDataReducer,
    siteData: siteDataReducer,
    tableBattery: tableBatteryReducer,
    permissions: permissionsReducer,
    config: configReducer
  });



// WEBPACK FOOTER //
// ./src/reducers/index.js